import { render, staticRenderFns } from "./SimpleListItem.vue?vue&type=template&id=9fd5b2b2"
import script from "./SimpleListItem.vue?vue&type=script&lang=js"
export * from "./SimpleListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports